export const assertNever = (x: never, filename: string = ''): never => {
  throw new Error(`${filename} | Unknown object ${JSON.stringify(x, null, 2)}`);
};
